import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import SEO from '@/components/SEO';

const DonationCanceled = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <SEO title="Got Cold Feet?" path="/donation-canceled" noindex />
      {/* Language Switcher */}
      <LanguageSwitcher />

      {/* Scanline overlay effect */}
      <div 
        className="pointer-events-none fixed inset-0 z-50 opacity-[0.03]"
        style={{
          background: 'repeating-linear-gradient(0deg, transparent, transparent 2px, hsl(120 100% 55% / 0.1) 2px, hsl(120 100% 55% / 0.1) 4px)'
        }}
      />

      <div className="relative z-10 text-center max-w-lg">
        {/* Emoji */}
        <div className="text-8xl mb-8 animate-pulse">
          😱
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-primary terminal-glow mb-4">
          {t('donationCanceled.title')}
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-primary mb-2">
          {t('donationCanceled.subtitle')}
        </p>

        {/* Message */}
        <p className="text-lg text-muted-foreground mb-8">
          {t('donationCanceled.message')}
        </p>

        {/* Terminal hint box */}
        <div className="terminal-border p-4 mb-8 text-left">
          <p className="text-muted-foreground text-sm font-mono">
            {t('donationCanceled.hint')}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col gap-4">
          <Link 
            to="/?open=donate"
            className="inline-block px-8 py-4 border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-200 font-bold tracking-wider glitch-hover"
          >
            {t('donationCanceled.tryAgain')}
          </Link>
          
          <Link 
            to="/"
            className="inline-block px-8 py-4 border-2 border-muted-foreground text-muted-foreground hover:border-primary hover:text-primary transition-all duration-200 font-bold tracking-wider"
          >
            {t('donationCanceled.backToHome')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DonationCanceled;
